import { createSelector } from "reselect";

export const isLoadingNotifications = (state) =>
  state.userNotification?.loadingNotifications;

export const selectNotifications = (state) =>
  state.userNotification.notifications || [];

export const selectUserNotificationById = createSelector(
  [(state, props) => props.identifier, selectNotifications],
  (notificationId, userNotifications) => {
    if (!userNotifications || userNotifications.length === 0) return null;
    if (!notificationId) return undefined;
    return userNotifications.find(
      (notification) => notification.id === notificationId,
    );
  },
);
